import { useQuery } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { plusButtonMutations } from "@/queries/plus-button/mutations";
import { usePlusButtonQueries } from "@/queries/plus-button/queryOptions";
import { useProjectQueries } from "@/queries/project/queryOptions";

import { PlusButtonOptionsContent, type PlusButtonOptionsContentProps } from "./PlusButtonOptionsContent";

export function PlusButtonOptionsPage(): React.ReactNode {
  const projectQueries = useProjectQueries();
  const plusButtonQuries = usePlusButtonQueries();
  const {
    data: buttonOptions,
    isFetching: isFetchingButtonOptions,
    error: errorPlusButtonOptions,
  } = useQuery(plusButtonQuries.list());
  const {
    data: projectDetails,
    isFetching: isFetchingProjectDetails,
    error: errorProjectDetails,
  } = useQuery(projectQueries.details());

  const createButtonOption = plusButtonMutations.useCreateButtonOption();
  const editButtonOption = plusButtonMutations.useEditButtonOption();
  const deleteButtonOption = plusButtonMutations.useDeleteButtonOption();

  const error = errorPlusButtonOptions || errorProjectDetails;
  if (error) {
    return <ErrorPage error={error} />;
  }

  const contentProps: PlusButtonOptionsContentProps = {
    buttonOptions: buttonOptions ?? [],
    isZiezodanProject: projectDetails?.isZiezodan ?? false,
    createOption: createButtonOption.mutateAsync,
    isCreatingOption: createButtonOption.isPending,
    editOption: editButtonOption.mutateAsync,
    isEditingOption: editButtonOption.isPending,
    deleteOption: deleteButtonOption.mutateAsync,
    isDeletingOption: deleteButtonOption.isPending,
    isLoading: isFetchingButtonOptions || isFetchingProjectDetails,
  };

  return <PlusButtonOptionsContent {...contentProps} />;
}
